$(document).ready(function () {
  // Show all cards by default
  $('.card').show();
  $('.filter-buttons button.all').addClass('selected');

  $('.filter-buttons button').click(function () {
    var category = $(this).data('category');

    // Remove 'selected' class from all buttons
    $('.filter-buttons button').removeClass('selected');

    // Add 'selected' class to the clicked button
    $(this).addClass('selected');

    if (category === 'all') {
      $('.card').show();
    } else {
      $('.card').hide();
      $('.' + category).show();
    }
  });
});
